import {useUpmPlant} from '@hconnect/upm'
import {useEffect} from 'react'

import {useKilns} from '@refra/modules/common/providers'
import {useOnboardKiln} from '@refra/modules/refra-planning/hooks/mutations'
import {useKilnDrillingSettingsQuery} from '@refra/modules/refra-planning/hooks/queries'
import {useUrlParam} from '@refra/modules/routing/hooks'

export const useValidateDrillingSettings = () => {
  const plantId = useUrlParam('plantCode')
  const upmPlant = useUpmPlant({plantId})
  const {selectedKiln} = useKilns()

  const {mutate: onboardKiln, isPending: isKilnOnboardingInProgress} = useOnboardKiln()

  const {
    data: drillingSettings,
    isLoading: areDrillingSettingsLoading,
    error: drillingSettingsError
  } = useKilnDrillingSettingsQuery({plantUpmId: upmPlant.upmId, kilnUpmId: selectedKiln.upmId})

  const areDrillingSettingsValid =
    !!drillingSettings &&
    drillingSettingsError?.response?.status !== 404 &&
    drillingSettings.drillingZones.length > 0 &&
    drillingSettings.drillingPositions.some(({isEnabled}) => isEnabled)

  useEffect(() => {
    if (drillingSettingsError?.response?.status === 404) {
      onboardKiln({plantUpmId: upmPlant.upmId, kilnUpmId: selectedKiln.upmId})
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [drillingSettingsError?.response?.status])

  return {
    areDrillingSettingsValid,
    areDrillingSettingsLoading: areDrillingSettingsLoading || isKilnOnboardingInProgress
  }
}
